import React, {Component} from 'react';
import './account.scss'
import {UserDto} from "../../../Models/UserDto";
import {Button, Icon} from "antd";
import loginIcon from "../../../Assets/icons/password.svg";

import {NavLink, Route} from "react-router-dom";
import profile from "./profile/profile";
export default class account extends Component {
  state={
    user:new UserDto()
  };
  componentDidMount() {
    let user:any=localStorage.getItem('UserData');
    let userInformation=JSON.parse(user);
    this.setState({ user: userInformation });
}
  render() {
    const {user} = this.state;
    return (
      <div className="page-account">
      <div className="row">
        <div className="col-md-3 p-10">

          <div className="card profile " >
            <div className="profile-img-upload">
              <img src={loginIcon} alt="" />
            </div>
            <div className="profile-name">
              {user.email}
            </div>
            <div className="profile-description">

            </div>
            <div className="profile-account">
              <div className="pb-10">
                  Account level :    {'Golden'}
              </div>
              <Button type="primary" className={'green-6'}  >
                  Upgrade Account
              </Button>
            </div>
            <div className="profile-options ">
              <div>
              Change Password
              </div>
              <div>
              Logout
              </div>
            </div>


          </div>
          <div className="card account-menu my-10 " >
            <div className="account-menu-tile">
                Account
            </div>

            <div className="row">
              <ul
              >
                <li key="1">
                  <NavLink activeClassName={'activeManu'}  to={'/panel/account/profile'}>
                    <Icon type="user" />
                    <span> User Information </span></NavLink>
                </li>
                <li key="2">
                  <NavLink activeClassName={'activeManu'}  to={'/panel/account/transaction'}>
                    <Icon type="wallet" />
                    <span> Transactions </span></NavLink>
                </li>

              </ul>

            </div>

          </div>
        </div>
        <div className="col-md-9 p-10">
          <div className="card" style={{ minHeight: 800}} >
            <Route path="/panel/account/profile" component={profile} />
          </div>
        </div>

      </div>
      </div>
    )
  }
}
